import React from 'react';
import './styles.scss';

export const StyledToggle = props => (
  <label className="styled-toggle-label">
    <input type="checkbox" {...props} />
    <span className={'slider round'} />
  </label>
);

const Toggle = ({ value, onChange, ...props }) => {
  return <StyledToggle checked={!!value} onChange={onChange} {...props} />;
};

export default Toggle;
